import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">
            <i className="ri-home-4-line"></i>
            <span className="ml-1">首页</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-xs"></i>
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: `${typeof window !== 'undefined' ? window.location.origin : ''}/`,
              },
              ...items
                .filter((i) => i.href !== undefined)
                .map((item, index) => ({
                  '@type': 'ListItem',
                  position: index + 2,
                  name: item.label,
                  item: item.href
                    ? `${typeof window !== 'undefined' ? window.location.origin : ''}${item.href}`
                    : '',
                })),
            ],
          }),
        }}
      />
    </nav>
  );
}